<template>
    <div v-if="this.solicitud">
        <b-card
        style="max-width: 100%;"
        :header="('Solicitud ' + this.solicitud.Id)">
            <b-row class="mb-2">
                <b-col cols="6"><h5>{{ this.solicitud.PersonalString }}</h5></b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4"><b>Tipo:</b> {{ this.solicitud.TipoSolicitudMedicaString }}</b-col>
                <b-col cols="4"><b>Fecha de solicitud:</b> {{ this.solicitud.Fecha | moment("DD-MM-YYYY") }}</b-col>
                <b-col cols="4"><b>Ausente desde:</b> {{ this.solicitud.FechaDesde | moment("DD-MM-YYYY") }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="2"><b>Cargos:</b></b-col>
                <b-col cols="10">
                    <cargo-personal-list :flush="false" :lista="this.solicitud.ListaCargoPersonal"></cargo-personal-list>
                </b-col>
            </b-row>
            <b-row class="mb-2 text-center">
              <b-col>
                <b-btn size="sm" variant="success" v-b-modal.modalHistorialLicencias>
                  <b-icon icon="clock"></b-icon> Ver Historial de licencias
                </b-btn>
              </b-col>
            </b-row>
        </b-card>
        <b-modal
          id="modalHistorialLicencias"
          :title="'Licencias ' + CurrentYear"
          header-bg-variant="dark"
          header-text-variant="light"
          size="lg"
          hide-footer
        >
          <card-licencias-resumen></card-licencias-resumen>
          <Calendar
          :disabled-week-days="[0,6]"
          :enable-context-menu="true"
          :context-menu-items="this.ContextMenuCalendar"
          :data-source="this.ListaLicenciasRange ? this.ListaLicenciasRange : []"
          :year="CurrentYear"
          :min-date="new Date((CurrentYear - 1) + '-01-01')"
          :max-date="new Date(CurrentYear + '-12-31')"
          language="es" render-style="background"></Calendar>
        </b-modal>
    </div>
</template>

<script>
import Calendar from 'v-year-calendar';
import 'v-year-calendar/locales/v-year-calendar.es';
import CargoPersonalList from './CargoPersonalList.vue'
import CardLicenciasResumen from './CardLicenciasResumen.vue'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment'
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  components: { CargoPersonalList, CardLicenciasResumen, Calendar },
  name: 'SolicitudCard',
  props: {
      solicitud: Object,
  },
  computed:{
    ...mapFormBuscarPersonalFields(['Personal_Id', 'ListaLicencias']),
    fechaSolicitud: function () {
        return (moment(this.solicitud.Fecha).format('DD MMM YYYY HH:MM'));
    },
    fechaAusenteDesde: function () {
        return (moment(this.solicitud.FechaDesde).format('DD MMM YYYY HH:MM'));
    },
    ContextMenuCalendar(){
      console.log('ContextMenuCalendar');
      return [
        {
          text: '',
          click: null
        }];
    },
    ListaLicenciasRange() {
      let listaRange = [];
      console.log('ListaLicenciasRange',this.ListaLicencias);
      const licenciasCurrentLastYear = this.ListaLicencias.filter(lic =>{
        let desde = new Date(lic.LicenciaDesde);
        return desde.getFullYear() === this.CurrentYear || desde.getFullYear() === this.LastYear;
      });
      licenciasCurrentLastYear.forEach(l => {
        listaRange.push({
          id: l.Id,
          name: l.DisplayArticulo,
          startDate: new Date(l.LicenciaDesde),
          endDate: new Date(l.LicenciaHasta)
        });
      });
      console.log('listaRange', listaRange);
      return listaRange;
    }
  },
  data(){
    return {
      dataSource: [],
      CurrentYear: new Date().getFullYear(),
      LastYear: (new Date().getFullYear()) - 1,
    }
  },
}
</script>
<style>
.calendar-context-menu
{
    z-index: 999999
}
</style>



// WEBPACK FOOTER //
// src/components/common/SolicitudCard.vue